import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import {
	Resolve,
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "../auth.service";
import { HttpClient } from "@angular/common/http";
import { CookieService } from "ngx-cookie-service";
import { isPlatformBrowser } from "@angular/common";

@Injectable({
	providedIn: "root",
})
export class DashBoardResolverService implements Resolve<any> {
	userDetails: any;
	loggedIn: boolean;
	constructor(
		private http: HttpClient,
		private auth: AuthService,
		private route: Router,
		private cookieService: CookieService,
		@Inject(PLATFORM_ID) private platformId: Object
	) {}
	resolve(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<any> {
		this.auth.checkLogin();
		this.auth.isUserLoggedIn.subscribe((val) => {
			if (val) {
				this.loggedIn = true;
			} else {
				this.loggedIn = false;
			}
		});
		if (this.loggedIn) {
			this.userDetails =
				this.auth.getCurrentUser() != null
					? this.auth.getCurrentUser()
					: route.parent.data.profileDetails.data;
			if ('KudosHub' in window && typeof window.KudosHub === 'function') {
				window.KudosHub('boot',{appId:'xAZjehRm_j27vj7ofmv41qt', email: this.userDetails.email, name:this.userDetails.first_name + " " + this.userDetails.last_name, created_at: Math.floor(new Date(this.userDetails.created_at).getTime() / 1000) })
				window.KudosHub("update", {appId:'xAZjehRm_j27vj7ofmv41qt', email:this.userDetails.email, name:this.userDetails.first_name + " " + this.userDetails.last_name, created_at: Math.floor(new Date(this.userDetails.created_at).getTime() / 1000) });
			} else {
				console.log('KudosHub is not defined on the window object.');
			}
			localStorage.setItem("uuid", this.userDetails.uuid);
			if (isPlatformBrowser(this.platformId)) {
				sessionStorage.setItem("key", this.userDetails.uuid);
			}
			const dateNow = new Date();
			dateNow.setMonth(dateNow.getMonth() + 6);
			this.cookieService.set("_khuuid", this.userDetails.uuid, { expires: dateNow, path: "/" });
			if (
				this.userDetails.email_list_cleaning_user_id == null &&
				this.userDetails.email_marketing_plan_id == null &&
				this.userDetails.livechat_user_id == null &&
				this.userDetails.notification_user_id == null
			) {
				this.route.navigate(["/services"]);
				return this.userDetails;
			} else {
				return this.userDetails;
			}
		} else {
			this.route.navigate([""]);
			return this.userDetails;
		}
	}
}